import { FaUsers, FaChartBar, FaCreditCard, FaCalendarAlt, FaComments, FaMobileAlt } from 'react-icons/fa';
import { useOutletContext } from 'react-router-dom';

const PRIMARY_BLUE = '#0056d2'; 

export default function Features() {
    const { openDemoModal } = useOutletContext(); // Access modal function

    const featureList = [
        {
            icon: FaUsers,
            title: 'Student & Batch Management',
            description: 'Effortlessly enroll, manage profiles, track attendance, and assign students to appropriate batches and coaching levels.',
        },
        {
            icon: FaCreditCard,
            title: 'Automated Fee Collection',
            description: 'Set up recurring payments, send automated invoice reminders, and integrate with major payment gateways to ensure timely collections.',
        },
        {
            icon: FaChartBar,
            title: 'Performance & Analytics',
            description: 'Generate detailed reports on student progress, coach efficiency, and financial health via an intuitive, visual dashboard.',
        },
        {
            icon: FaCalendarAlt,
            title: 'Scheduling & Rostering',
            description: 'Handle complex timetables, manage room/resource booking, and allow coaches to easily view and update their class schedules.',
        },
        {
            icon: FaComments,
            title: 'Parent/Coach Communication',
            description: 'Built-in chat and notification system for instant updates, announcements, and direct, secure communication channels.',
        },
        {
            icon: FaMobileAlt,
            title: 'Dedicated Mobile Access',
            description: 'Native mobile app access for parents, students, and coaches to view schedules, reports, and make payments on the go.',
        },
    ];

    return (
        <div className="bg-white py-5">
            <div className="container py-lg-5">
                
                {/* Header */}
                <header className="text-center mb-5 mb-lg-5">
                    <h1 className="display-5 fw-bold text-dark mb-3">Powerful Features Built for <span style={{ color: PRIMARY_BLUE }}>Academy Growth</span></h1>
                    <p className="lead text-secondary mx-auto" style={{ maxWidth: '800px' }}>
                        Aadhav Software provides every tool you need to centralize administration, enhance student engagement, and scale your operations without friction.
                    </p>
                </header>

                {/* Features Grid */}
                <div className="row g-4">
                    {featureList.map((feature, index) => (
                        <div key={index} className="col-lg-4 col-md-6">
                            <div className="p-4 rounded-4 h-100 shadow-sm" style={{ border: '1px solid #e9ecef', transition: 'box-shadow 0.3s' }}>
                                <feature.icon size={40} style={{ color: PRIMARY_BLUE }} className="mb-3" />
                                <h5 className="fw-bold text-dark mb-2">{feature.title}</h5>
                                <p className="text-muted small">{feature.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Secondary CTA */}
                <div className="text-center mt-5 pt-4">
                    <h3 className="fw-bold text-dark mb-3">Ready to See the Full Platform?</h3>
                    <button
                        className="btn text-white fw-bold btn-lg px-5 py-3"
                        style={{ 
                            background: PRIMARY_BLUE,
                            border: 'none', 
                            borderRadius: '6px', 
                            boxShadow: '0 4px 10px rgba(0, 86, 210, 0.3)'
                        }}
                        onClick={openDemoModal}
                    >
                        Schedule a Personalized Demo
                    </button>
                </div>

            </div>
        </div>
    );
}